import { UserResponse } from '@/modules/api/openapi/models/UserResponse'

/**
 * Identity of the account an Intercom session belongs to, or undefined when no session
 * should exist for the current user.
 *
 * Intercom is suppressed while impersonating. `/users/me` resolves to the authenticated
 * admin's own id and email under impersonation -- only the organization belongs to the
 * impersonated user -- so booting would attach an internal admin contact, along with
 * their conversation history, to the customer's Intercom company record.
 *
 * Callers pass `getImpersonatedUserId()`. The parameter is required so a new call site
 * cannot silently opt out of the suppression by omitting it, and its truthiness must stay
 * in step with the `IMPERSONATED-USER` request header, which is likewise omitted when the
 * stored id is empty.
 */
export const buildIntercomIdentity = (
  firebaseUid: string | undefined,
  user: Pick<UserResponse, 'id' | 'organizationId'>,
  impersonatedUserId: string | undefined
): string | undefined =>
  firebaseUid && !impersonatedUserId
    ? `${firebaseUid}:${user.id}:${user.organizationId}`
    : undefined
